import { observer } from 'mobx-react';
import Counter4_0 from './Counter4_0';
import Counter4_1 from './Counter4_1';
import Counter4_2 from './Counter4_2';
import Counter4_3 from './Counter4_3';
import Counter4_4 from './Counter4_4';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  utilized: number;
}

function FourOfferingTypes({ utilized }: Props) {
  switch (utilized) {
    case 0:
      return <Counter4_0 />;
    case 1:
      return <Counter4_1 />;
    case 2:
      return <Counter4_2 />;
    case 3:
      return <Counter4_3 />;
    case 5:
      return <Counter4_4 />;
    default:
      return emptyFragment();
  }
}

export default observer(FourOfferingTypes);
